export const EXCMTAG_CREATE_RESET = 'EXCMTAG_CREATE_RESET'
export const EXCMTAG_CREATE_SET_CREATED = 'EXCMTAG_CREATE_SET_CREATED'
export const EXCMTAG_CREATE_SET_ERROR = 'EXCMTAG_CREATE_SET_ERROR'
export const EXCMTAG_CREATE_SET_VIOLATIONS = 'EXCMTAG_CREATE_SET_VIOLATIONS'
export const EXCMTAG_CREATE_TOGGLE_LOADING = 'EXCMTAG_CREATE_TOGGLE_LOADING'
